// 关于我们
const about = {
  'about.tab.title': '私たちについて',
  'about.welcome': 'QuickFox へようこそ、',
  'about.list.check': '更新を確認',
  'about.list.contact': 'お問い合わせ',
  'about.list.like': '良い評価をお願いします',
  'about.list.terms': '利用規約',
  'about.list.policy': 'プライバシーポリシー',
  'about.list.vip': '会員サービス契約',
};
// 联系我们
const contact = {
  'contact.tab.title': 'お問い合わせ',
  'contact.title': '以下の方法でお問い合わせいただけます',
  'contact.list.offcial': '公式ウェブサイト',
  'contact.list.wx': 'WeChat 公式アカウント',
  'contact.list.qq': 'カスタマーサービス QQ',
  'contact.list.qqgroup': '公式 QQ グループ',
  'contact.list.wxkf': 'テクニカルサポート WeChat',
  'contact.list.email': 'メール',
  'contact.list.op.visit': '訪問する',
  'contact.list.op.copy': '番号をコピー',
  'contact.list.op.copyAccount': 'アカウントをコピー',
  'contact.list.op.copy.mail': 'アドレスをコピー',
  'contact.copy': 'コピー成功',
}
// 帮助
const help = {
  'help.tab.title': 'ヘルプ',
  'help.title': '人間の助けが必要ですか？オンラインカスタマーサービスに連絡するにはクリックしてください',
  'help.contact': '今すぐ連絡',
  'help.head.speedUp': '加速',
  'help.head.recharge': 'チャージ',
  'help.head.other': 'その他',
  'help.pv': 'ヘルプページの閲覧数',
  'help.speed': '加速',
  'help.other': 'その他',
  'help.vip': '会員',
};
// 帮助详情
const helpDetail = {
  'helpDetail.tab.title': '詳細',
  'helpDetail.about': '関連質問',
};
const notice = {
  'notice.tab.title': 'メッセージセンター',
  'notice.nodata': 'まだメッセージはありません～',
  'notice.numberOfMsgJumpClick': 'サイト内メッセージボタンから会員ページへのクリック率',
  'notice.getItRightnow': 'クリックして受け取る',
  'notice.allReadyGetIt': '受け取り済み',
  'notice.getItSuccessfully': '受け取り成功',
  'notice.rechargeNow': '今すぐチャージ',
};

// 技术支持
const tsupport = {
  'tsupport.title': 'テクニカルサポート',
  'tsupport.wechatDesc': 'QuickFox テクニカルサポート',
  'tsupport.addService': '今すぐカスタマーサービスを追加',
  'tsupport.tip': '使用中にクラッシュ、加速不能、遅延など正常な使用に影響を与える問題が発生した場合は、お気軽にご連絡ください。',
  'tsupport.unSupport': 'まだサポートされていません',
};

// Http
const http = {
  'http.prompt.networkError': 'ネットワークエラー',
};
const Welfare = {
  'welfare.header.todayincome': '今日の収益',
  'welfare.header.totalincome': '累計収益',
  'welfare.coinsTasks': 'ゴールドコイン任務',
  'welfare.tasksCard.chekout': '表示',
  'welfare.tasksCard.coins': 'ゴールドコイン',
  'welfare.tasks.invite': '招待特典',
  'welfare.tasks.invite.unit': 'ゴールドコイン / 人',
  'welfare.tasks.invite.desc': '年間メンバーシップ獲得の招待',
  'welfare.tasks.invite.descript': '友達を招待してゴールドコインを獲得、百万の赤い封筒が待っています',
  'welfare.tasks.sign': '毎日チェックイン',
  'welfare.tasks.sign.descript': '1 日最大 50 コインを獲得できます',
  'welfare.tasks.wx': '公式アカウントをフォロー',
  'welfare.tasks.bindEmail': 'バインド特典',
  'welfare.tasks.bindText': 'バインドへ',
  'welfare.tasks.bindEmail.descript': 'メールまたは電話番号をバインドしてコインを獲得',
  'welfare.tasks.bindEmail.desc': '+6 時間 VIP 期間',
  'welfare.tasks.bindEmail.bindTimes': '+6 時間 VIP',
  'welfare.tasks.share': 'シェアで報酬',
  'welfare.tasks.share.descript': 'ソーシャルメディアでポスターをシェアし、スクリーンショットをアップロードして 100 コインをゲット',
  'welfare.tasks.wx.descript': 'QuickFox 公式 WeChat アカウントをフォローして 30 コインをゲット',
  'welfare.sign.dayno': '{day} 日目',
  'welfare.sign.vipTime': '{vipTime}{vipTimeType}VIP',
  'welfare.sign.ticket': '50元クーポン',
  'welfare.sign.day': '日',
  'welfare.sign.hadSign': '連続チェックイン',
  'welfare.sign.sign': 'チェックイン',
  'welfare.sign.signed': 'チェックイン済み',
  'welfare.sign.tips': '連続チェックインで豊富な報酬がもらえますよ～',
  'welfare.sign.successText': 'チェックイン成功',
  'welfare.sign.rule.title': 'チェックインルール',
  'welfare.sign.rule.modalTitle': 'チェックインルール',
  'welfare.sign.rule.7day': 'サインイン成功おめでとうございます! {vipTime} {vipTimeType} VIP期間を取得しました。',
  'welfare.sign.rule.download': 'QuickFoxアプリをダウンロード',
  'welfare.sign.rule.downloadLast': '加速をお楽しみいただけます。 ',
  'welfare.sign.rule.yancaoRedpack': 'Gonest500元以上のお買い上げで50元割引の送料クーポンを受け取りました',
  'welfare.sign.rule.eventTime': 'イベント時間: 2024-12-24 12:00 ～ 2025-1-2 18:00',
  'welfare.sign.rule.part1': '{signCount} 連続 {signTimeType} チェックインごとに、{rewardVipTime} {rewardTimeType} VIP 期間を獲得できます；',
  'welfare.sign.rule.part2': '{signCount} 連続 {signTimeType} チェック인ごとに、{rewardVipTime} {rewardTimeType} VIP 期間을 획득할 수 있습니다;',
  'welfare.sign.rule.part3': 'チェックインが中断されると、日数の計算がリセットされます；',
  'welfare.sign.rule.part4': '同一デバイスでの複数回の登録はチェックイン報酬を記録せず、不正な手段でチェックイン報酬を取得することは禁止されています。',
  'welfare.sign.rule.interpretation': 'クイックフォックス所有',
  'welfare.sign.successTips': 'チェックイン成功、{todayReward} コインを獲得しました。毎日来るのを忘れずに～',
  'welfare.sign.signSuccess': '成功',
  'welfare.sign.signSuccessVip': 'チェックイン成功，{vipTime}{timeType} VIP 時間が手に入りました，毎日来るのを忘れないでください～',
  'welfare.sign.ruleDetail': '毎日チェックインで 2 コイン獲得。7 日連続チェックインで追加報酬。1 日最大 50 コイン。毎日参加してくださいね！',
  'welfare.sign.ruleDetail2': '同じデバイスでの複数回の登録はコイン報酬が記録されません。不正な手段でコイン報酬を取得することは禁止されています。QuickFox はコイン報酬を取り消し、交換注文を閉じる権利を有します。',
  'welfare.wx.follow': '公式アカウントをフォロー',
  'welfare.wx.welfareForInvite': '招待特典',
  'welfare.wx.signIn': 'シェア特典',
  'welfare.wx.toSignIn': 'チェックインへ',
  'welfare.wx.toFollow': 'フォローへ',
  'welfare.wx.toInvite': '招待する',
  'welfare.wx.toGet': '利用可能',
  'welfare.wx.toGetHighest': '最大報酬',
  'welfare.wx.qrcodeTip.saved': 'QR コードがアルバムに保存されました',
  'welfare.wx.qrcodeTip.failed': 'QR コードの保存に失敗しました',
  'welfare.wx.qrcodeTip.version': 'QR コードを保存するには最新バージョンをダウンロードしてください！',
  'welfare.wx.Intro.title': 'タスク紹介',
  'welfare.wx.Intro.step': 'ステップ ',
  'welfare.wx.Intro.follow': 'フォロー',
  'welfare.wx.Intro.reward': '報酬',
  'welfare.wx.Intro.rewardText1.part1': 'フォローで獲得',
  'welfare.wx.Intro.rewardText1.part2': '{vipCount} 時間 VIP',
  'welfare.wx.Intro.pc.scanit': 'WeChat の「スキャン」で下の画像をスキャンしてください',
  'welfare.wx.Intro.mobile.scanit': '下の QR コードをアルバムに保存し、WeChat を開いて「スキャン」を選択してスキャンしてください',
  'welfare.wx.Intro.follow.descrip': '右上の「フォロー」ボタンをクリックしてタスクを完了してください',
  'welfare.invite.rule.title': '招待ルール',
  'welfare.invite.personNum': '「招待成功 (人)」',
  'welfare.invite.viewDetail': '詳細を見る',
  'welfare.invite.inviteDetail': '招待詳細',
  'welfare.invite.coinNum': '招待報酬 (コイン)',
  'welfare.invite.dayNum': '招待報酬 (日)',
  'welfare.invite.duration': '贈与期間 (日)',
  'welfare.invite.toGoods': 'コイン交換',
  'welfare.invite.rewardDetail': '報酬詳細',
  'welfare.invite.face2face': 'ポスター＆対面招待クリック',
  'welfare.invite.copyLink': '招待リンクをコピー',
  'welfare.invite.post.saved': 'ポスターがアルバムに保存されました',
  'welfare.invite.post.failed': 'ポスターの保存に失敗しました',
  'welfare.invite.post.descrip.tips': 'ポスターまたはスクリーンショットを保存して友達と共有し、友達に QR コードをスキャンするように招待すると、招待が成功するとあなたと友達はそれぞれ 100 ゴールドコインを受け取ります',
  'welfare.invite.post.version': 'ポスターを保存するには最新バージョンをダウンロードする必要があります！',
  'welfare.invite.post.pcAppTip': 'QuickFox アプリでポスターを保存してください！',
  'welfare.invite.post.saveBtn': 'ポスターを保存',
  'welfare.invite.post.descrip.regist': 'QR コードをスキャンして登録QuickFox アカウント，',
  'welfare.invite.post.descrip.speedOnce': 'アプリをダウンロード加速を一度使用，',
  'welfare.invite.post.descrip.getCoins': 'あなたと友達それぞれ 100 ゴールドを獲得，',
  'welfare.invite.process.regist': '友達がクリック招待リンクで登録，',
  'welfare.invite.process.speedOnce': 'アプリをダウンロード加速を 1 回使用，',
  'welfare.invite.process.getCoins': 'あなたと友達それぞれ 100 ゴールドを獲得，',
  'welfare.invite.process.tips': '* 友達は新しいモバイルデバイス（つまり、以前に QuickFox アカウントにログインしたことのない電話）で招待リンクに登録されたアカウントにログインし、加速を 1 回使用して報酬を受け取る必要があります。',
  'welfare.invite.link.title': 'スーパー VIP を請求できます ',
  'welfare.invite.link.descrip': 'QuickFox アクセラレーターが特典を配布中です。登録するとスーパー VIP がもらえ、現金の赤い封筒もあなたを待っています！',
  'welfare.invite.historyBtn': '招待の詳細 ',
};
const PageTitle = {
  'pageTitle.goods': 'ショッピングモール ',
  'pageTitle.welfare': '福利 ',
  'pageTitle.invite.detail': '招待明細 ',
  'pageTitle.taskDetails': '公式アカウントをフォロー ',
  'pageTitle.inviteDetails': '招待して報酬を得る ',
  'pageTitle.taskSignin': '毎日チェックイン ',
  'pageTitle.taskCenter': 'タスクセンター ',
  'pageTitle.taskEmail': 'メールをバインド ',
  'pageTitle.taskShare': '報酬のために共有 ',
  'pageTitle.appApplyRecord': '申請記録 ',
};
const Common = {
  'common.ok': 'はい ',
  'common.confirm': '確認 ',
  'common.cancel': 'キャンセル ',
  'common.avatar': 'アバター ',
  'common.iSee': 'わかりました ',
  'common.human': '人 ',
  'common.requreUpdate': '現在のバージョンは古すぎます。最新バージョンに更新してください。',
  'common.currency.dollar': 'ドル ',
  'common.free': '無料 ',
  'common.currency.rmb': '元 ',
  'common.init': 'プロジェクトを初期化中 ',
  'common.payType.offline': 'オフライン支払い ',
  'common.payType.alipay': 'アリペイ ',
  'common.payType.wxMiniProg': 'WeChat ミニプログラム ',
  'common.payType.wx': 'WeChat',
  'common.payType.bank': '銀行カード / クレジットカード',
  'common.selectPlaceholder': '選択されていません',
  'common.loading': '読み込み中',
  'common.noMore': 'これ以上はありません',
};
const Tips = {
  'tips.pleaselogin': 'まずログインしてください ',
  'tips.pleaselogin.event': 'ログイン後にイベントに参加できますよ～',
  'tips.gologin': 'ログインへ ',
  'tips.loadFailed': '読み込み失敗 ',
  'tips.listLoadFailed': 'リストの読み込みに失敗しました ',
  'tips.loadFailed.retry': '読み込みに失敗しました。後でもう一度お試しください ',
  'tips.refreshed': '更新しました ',
  'tips.refreshFailed': '更新エラー ',
  'tips.saving': '保存中...',
  'tips.saveQrcode': 'QR コードを保存',
  'tips.copyed': 'コピー成功 ',
  'tips.loadingHard': '必死にロード中、少々お待ちください...',
  'tips.loading': 'ロード中...',
  'tips.nodata.forNow': 'データなし ',
  'tips.load.success': 'ロード完了 ',
  'tips.goingToPay': '支払いに移動中...',
  'tips.cancelSuccessful': 'キャンセル成功 ',
  'tips.failToRefreshOrder': '注文の更新に失敗しました ',
  'tips.refreshOrderError': '注文の更新中にエラーが発生しました ',
  'tips.refreshListError': 'リストの更新中にエラーが発生しました ',
  'tips.refreshListDone': 'リストが更新されました ',
  'tips.pull2Refresh': '下に引っ張って更新 ',
  'tips.release2Refresh': 'リリースして更新 ',
  'tips.refreshing': '更新中 ',
};
// 开通记录
const ActivationRecord = {
  'record.records': 'アクティベーション記録 ',
  'record.options': '操作 ',
  'record.memberRefund': '会員返金 ',
  'record.syncOrder': '注文を同期 ',
  'record.tip': '親切なリマインダー ',
  'record.tipDesc': 'QuickFox スーパー VIP 月額サブスクリプションサービスをキャンセルしてもよろしいですか？これによりアカウントの更新が停止され、期限切れ後は VIP 専用ルートが利用できなくなります。',
  'record.memberPage.pageViewsOfActivationRecord': 'メンバーページ - サブスクリプション記録ページビュー ',
  'record.refundFail.tryAgain': '返金リクエストが失敗しました。後でもう一度お試しください。',
  'record.cancel': 'キャンセル ',
  'record.noRecordYet.goAndActive': 'まだ記録がありません、急いで会員登録してください～',
  'record.chooseRefundOrder': '返金注文を選択 ',
  'record.weSupportRefund.oneUserHasOneService': 'スーパー VIP メンバーシップを購入後 7 日以内に返金を申請できます。返金する注文を選択してください。返金後、資金は元の支払い方法に返金されます。各ユーザーは返金サービスを一度しか利用できません。',
  'record.failToGetList': 'リストの取得に失敗しました ',
  'record.failToGetActivationList': 'アクティベーション記録リストの取得に失敗しました ',
  'record.failToGetRefund': '返金状況の取得に失敗しました ',
  'record.getListFail': 'リストの取得に失敗しました ',
  'record.recordItem.numberOfRefund': 'メンバーシップページ - サブスクリプション記録、注文カードの返金ボタンクリック数 ',
  'record.recordItem.getTime': '取得時間 ',
  'record.recordItem.refundTime': '返金時間 ',
  'record.recordItem.refuseRefund': '返金不可 ',
  'record.recordItem.refundComplete': '返金完了 ',
  'record.recordItem.addDay': '特典期間 ',
  'record.recordItem.handsel': 'プレゼント ',
  'record.recordItem.orderNumber': '注文番号 ',
  'record.recordItem.orderType': '支払い方法 ',
  'record.recordItem.orderNumberHasBeenCopied': '注文番号がコピーされました ',
  'record.recordItem.refund': '返金 ',
  'record.recordItem.outActivity': '外部活動 ',
  'record.resaonModal.refundReason': '返金理由 ',
  'record.resaonModal.supplement': '追加説明 ',
  'record.resaonModal.refundReasonPlaceholder': '任意です。返金が必要な理由を教えてください、できるだけ早く最適化します。最大 50 文字入力可能です。',
  'record.resaonModal.reasonLimitedText': '最大 50 文字まで入力可能です。',
  'record.resaonModal.failToSubmitRefundRequset': '返金申請の提出に失敗しました。',
  'record.resaonModal.refundApplication': '返金申請 ',
  'record.reasonModal.failToRefund': '操作失敗 ',
  'record.reasonModal.successfulRefund': '操作成功 ',
  'record.reasonModal.weSupportRefund.reviewDetailonITunes': 'スーパー VIP メンバーシップ購入後 7 日以内の返金リクエストをサポートしています。iTunes で注文を確認し、返金リクエストを提出してください。',
  'record.reasonModal.numberOfConfirmRefund': '会員ページ - アクティベーション記録ページ、返金ボタンのクリック数を確認 ',
  'record.reasonModal.ok': 'はい ',
};
// 时间类型(通用)
const TimeType = {
  'timeType.day': '日 ',
  'timeType.week': '週 ',
  'timeType.month': '月 ',
  'timeType.season': '季節 ',
  'timeType.year': '年 ',
  'timeType.minute': '分 ',
  'timeType.hour': '時間 ',
  'timeType.sentence': '{day} 日 {hour} 時間 {minute} 分 {second} 秒 ',
};
// 防锁定教程
const tutorial = {
  'tutorial.mi': 'シャオミ スマホ チュートリアル ',
  'tutorial.vivo': 'ビボ スマホ チュートリアル ',
  'tutorial.oppo': 'オッポ スマホ チュートリアル ',
  'tutorial.huawei': 'ファーウェイ スマホ チュートリアル ',
  'tutorial.honor': 'オナー スマホ チュートリアル ',
  'tutorial.oneplus': 'ワンプラス携帯電話チュートリアル ',
  'tutorial.samsung': 'サムスン携帯電話チュートリアル ',
  'tutorial.general': 'その他の携帯電話チュートリアル ',
  'tutorial.tips': '携帯電話のブランドを選択して、対応するチュートリアルを表示してください ',
  'tutorial.title': '高速化と切断防止チュートリアル ',
  'tutorial.purchase.title': 'スーパー VIP を購入 ',
  'tutorial.purchase.content0': 'Google Play でのメンバーシップ購入時に支払いが完了しない場合は、以下の方法をお試しください:',
  'tutorial.purchase.title1': '1. 公式サイトでメンバーシップを購入 ',
  'tutorial.purchase.content1': '以下のボタンをクリックして公式サイトでメンバーシップを購入できます。WeChat/Alipay/PayPal などの支払い方法をサポートしており、価格もお得です；',
  'tutorial.purchase.title2': '2. QuickFox の最新バージョンをインストール ',
  'tutorial.purchase.content2': 'QuickFox の公式サイトから最新バージョンをダウンロードでき、WeChat/Alipay/PayPal などの支払い方法をサポートしています；',
  'tutorial.purchase.title3': '3. カスタマーサービスに連絡して購入 ',
  'tutorial.purchase.content3': 'QuickFox は、WeChat/Alipay/ 銀行を通じて QR コードのスキャンまたは振り込みで Super VIP を購入できます。アプリの左上をクリックしてカスタマーサービスに相談するか、公式 WeChat アカウント QuickFox2020 を追加して問い合わせることができます。',
  'tutorial.purchase.button': '公式ウェブサイトで購入する ',
  'tutorial.purchase.button1': '最新バージョンをダウンロード ',
};
// 邀请裂变1, 2期活动结束
const pointEventEnd = {
  'pointEventEnd.tooltipText': '残念ながら、イベントは終了しました ',
  'pointEventEnd.invitationWithPrize': '招待して報酬を得る ',
  'pointEventEnd.scanQRToFollow': 'QR コードをスキャンして公式アカウントをフォローし、また会いましょう～',
  'pointEventEnd.scanQRToFollowForMoreInfo': 'QuickFox 公式アカウントをフォローして、よりエキサイティングなイベント情報を入手してください。',
  'pointEventEnd.copyOfficialAccount': '公式アカウントをコピー ',
};
// 邀请裂变第3期
const taskCenterV3 = {
  'task.mission.pv': 'タスクセンターのページビュー ',
  'task.lookforwardForMoreTasks': 'さらに多くのタスクをお楽しみに ',
  'task.taskCard.isPcAppNotice': '招待タスクは現在モバイルでのみサポートされています。QR コードをスキャンして QuickFox アプリをダウンロードし、タスクを完了してください。',
  'task.taskCard.numberOfInvitationClick': '招待タスクのクリック数 ',
  'task.taskCard.numberOfFollowTaskClick': '公式アカウントタスククリック数 ',
  'task.taskCard.numberOfCheckInClick': '福利ページ、チェックインタスククリック数 ',
  'task.detail.follow.numberOfFollowPage': '公式アカウントタスクページビュー ',
  'task.invite.invitePagePv': '招待タスクページビュー ',
  'task.invite.cpoyPv': '招待リンクコピークリック数 ',
  'task.invite.loadingText': 'まだ記録がありません、友達を招待しましょう～',
  'task.invite.nodataText': 'まだ記録がありません、早く任務を完了してコインを獲得しましょう～',
  'task.invite.noContentText': '記録なし ',
  'task.invite.noContentTextPart1': '早く友達を招待しましょう ',
  'task.invite.coinDetail': 'コインの詳細 ',
  'task.invite.coinDetailPv': 'コインの詳細ページビュー ',
  'task.invite.numberOfClickInviteBtn': '招待ボタンのクリック数 ',
  'task.invite.posterAndFace2Face': 'ポスター＆対面招待 ',
  'task.invite.inviteForNow': '今すぐ招待 ',
  'task.invite.linkCopied': 'リンクをコピーしました ',
  'task.invite.posterLoading': 'ポスターを読み込み中...',
  'task.invite.descript.title.part1': '招待した友達 1 人につき、最大で ',
  'task.invite.descript.title.part2': '今すぐ招待しましょう ',
  'task.invite.reward.descrip': '報酬 ',
  'task.invite.reward.descrip.part1': '1. 招待された友人がモバイル端末でアクセラレーションを1回使用すると、友人は30分間のVIP時間報酬を獲得できます。',
  'task.invite.reward.descrip.part2': '2. 招待した友達が VIP 購入を完了すると、友達の購入期間の 10％を紹介報酬として受け取ります。',
  'task.invite.reward.descrip.part3': '3. 不正な手段で一括登録すると、違反とみなされ、招待報酬は受け取れません。',
  'task.invite.reward.descrip.part4': '4. 友達が返金した場合、該当する招待報酬は取り消されます。',
  'task.invite.reward.descrip.part5': '2. 招待した友達が VIP 購入を完了すると、購入期間の 10％ + 5％が報酬として受け取れます。',
  'task.invite.details.tab.waitingData': '加速待ち ',
  'task.invite.details.tab.waitingToGiveData': '配布待ち ',
  'task.invite.details.tab.completedData': '完了 ',
  'task.invite.details.tab.inValidData': '期限切れ ',
  'task.invite.details.tab.closed': '閉じました ',
  'task.invite.details.tab.toAppeal': '申し立て待ち ',
  'task.invite.details.tab.toPaid': '支払い待ち ',
  'task.invite.details.tab.violationData': '違反ユーザー ',
  'task.invite.details.content.type1': '友達が登録を完了しました。新しいデバイスでアプリをダウンロードし、そのアカウントでスピードブーストを行うよう友達に依頼してください。報酬は 1 時間以内に到着します。',
  'task.invite.details.content.type2': 'お友達の招待が完了し、30分のVIPタイム特典が付与されました。',
  'task.invite.details.content.type3': 'あら、この友達は新しいデバイスで最初のスピードブーストを行いませんでした。この招待は失敗しました～',
  'task.invite.details.content.type4': 'お友達の招待が完了し、システムリスク審査が進行中です。お友達の30分のVIPタイム特典は、1時間以内にお客様のアカウントに付与されます。',
  'task.invite.details.content.type5': 'この友達はルール違反をしたため、報酬を発行できません ',
  'task.invite.details.loading': '招待明細を読み込んでいます...',
  'task.invite.details.load.faild': '招待明細の読み込みに失敗しました ',
  'task.signin.viewPv': '福利 - チェックインページ、ページビュー ',
  'task.signin.walfare': '新規ユーザーチェックイン特典 ',
  'task.signin.walfare.detail': '友達の招待で登録後 7 日以内に 3 日連続でチェックインすると、追加で 100 ゴールドコインを獲得できます。招待キャンペーンに参加して友達を招待し、一緒にチェックインすると、同じチェックインゴールドコイン報酬を獲得できます。',
  'task.signin.walfare.downloadForSignin': 'QuickFox アプリをダウンロードして友達を招待してチェックイン ',
  'task.signin.walfare.goToInviteWithPhone': 'モバイルで招待する ',
  'task.signin.walfare.goToInvite': '招待する >',
  'task.signin.walfare.numberOfCheckInClick': '福利 - チェックインタスクページ、チェックインクリック ',
  'task.signin.walfare.signing': 'チェックインデータをロード中です、少々お待ちください...',
  'task.signin.walfare.signSuccessTipsPart1': 'チェックイン成功、{todayReward} ゴールドコインを獲得、',
  'task.signin.walfare.signSuccessTipsPart2': '新規ユーザーとして、連続チェックイン特典を受け取りました。さらに 100 コインをプレゼントします～',
  'task.signin.walfare.signSuccessTipsPart3': '毎日来るのを忘れないでね～',
  'task.goods.detail.title': '商品詳細 ',
  'task.goods.detail.lessCoin': 'コイン不足 ',
  'task.goods.detail.lessCoinTips': 'コインが足りません。もっとコインを稼ぐためにタスクを完了してください～',
  'task.goods.detail.lessCoinTips.goForMoreCoin': 'コインが足りません。もっとコインを稼ぐためにタスクを完了してください～iOS デバイスは現在差額の補充をサポートしていません。他のシステムデバイスで交換を行ってください ',
  'task.goods.detail.exchangeRes.goCheck': '交換に成功しました。"交換記録" ページで商品を確認し、受け取ることができます。',
  'task.goods.detail.exchange': '商品を交換する ',
  'task.goods.detail.exchangeSuccessful': '交換成功 ',
  'task.goods.detail.exchangeSuccessful.congratulate': 'おめでとうございます。交換に成功しました。以下の方法で商品を受け取ることができます～',
  'task.goods.detail.exchangeSuccessful.tips': 'おめでとうございます。交換申請が成功しました。2 営業日以内に審査を完了し、"交換記録" ページで進捗状況を確認できます～',
  'task.goods.detail.exchangeSuccessful.getVip': '交換に成功しました。スーパー VIP 特権があなたのアカウントにチャージされました。',
  'task.goods.detail.exchange.fail.retry': '交換に失敗しました、後でもう一度お試しください ',
  'task.goods.detail.exchangeConfirm': 'この商品を交換しますか？',
  'task.goods.detail.stock.less': '在庫不足 ',
  'task.goods.detail.stock.less.tips': 'この商品は在庫不足のため、一時的に交換できません～',
  'task.goods.detail.signinDay.less': 'チェックイン日数不足 ',
  'task.goods.detail.signinDay.less.tips': 'この商品は {day} 回以上のチェックインが必要です、急いでチェックインしてください～',
  'task.goods.detail.remain': '残り ',
  'task.goods.detail.tillNext': '次のフラッシュセールまで ',
  'task.goods.blockTitle': '商品紹介 ',
  'task.goods.noStock': '在庫切れ ',
  'task.goods.noConvertible': '交換不可 ',
  'task.goods.overConvertibleLimit': '交換上限に達しました ',
  'task.goods.exchange.now': '今すぐ交換 ',
  'task.goods.order.total': '注文合計 ',
  'task.goods.coinForPay': 'コインで支払う ',
  'task.goods.require.diff': '価格差が必要 ',
  'task.goods.pay.diff': '差額を支払う ',
  'task.goods.pay.diff.exchange': '差額を支払って交換 ',
  'task.goods.pay.way': '支払い方法を選択 ',
  'task.goods.contact.offcialAccount': 'QuickFox WeChat カスタマーサービス {number} に連絡 ',
  'task.goods.offcialAccount.copy': '(WeChat ID をコピーするにはクリック)',
  'task.goods.contact.customerService': 'QuickFox WeChat カスタマーサービスに連絡 ',
  'task.goods.go': '今すぐ行く ',
  'task.point.detail.coinType0': 'コイン抽選 ',
  'task.point.detail.coinType1': 'コイン交換 ',
  'task.point.detail.coinType2': '友達 {account} を招待して登録 ',
  'task.point.detail.coinType3': '友達招待で登録 ',
  'task.point.detail.coinType4': '上位ランクユーザーのプラットフォーム報酬 ',
  'task.point.detail.coinType5': 'デイリーチェックイン ',
  'task.point.detail.coinType6': 'WeChat 公式アカウントをフォロー ',
  'task.point.detail.coinType7': 'モール交換注文の期限切れ ',
  'task.point.detail.coinType8': 'ゴールドコインくじの収益 ',
  'task.point.detail.coinType9': '3 日連続チェックインの追加報酬 ',
  'task.point.detail.coinType10': '友達の 3 日連続チェックイン追加報酬 ',
  'task.point.detail.bindReward': 'バインディングギフト ',
  'task.point.detail.shareReward': 'シェアタスク報酬 ',
  'task.point.detail.coinType11': '中秋祭りゴールドコイン配布 ',
  'task.point.detail.coinType13': 'ゴールドコイン期限切れ ',
  'task.point.detail.coinType16': 'ワールドカップ予想イベント ',
  'task.redeem.modal.title': 'まだサポートされていません ',
  'task.redeem.modal.content': 'iOS デバイスは現在、追加料金交換をサポートしていません。他のシステムデバイスで交換を行ってください。',
  'task.redeem.exchangeRecordPv': '交換記録閲覧数 ',
  'task.redeem.exchangeRecord': '交換記録 ',
  'task.redeem.exchangeCode': '交換コード:',
  'task.redeem.draw.link': '受け取りリンク:',
  'task.redeem.draw.code': '商品受け取りコード:',
  'task.redeem.exchangeCode.use': '交換方法 ',
  'task.redeem.norecord.goForIt': 'まだ記録がありません、早く商品を交換しましょう～',
  'task.redeem.record.tips': 'QuickFox は 2 営業日（月曜日から金曜日までが営業日）以内に配布を完了します。配布後はできるだけ早く確認してご利用ください。',
  'task.redeem.clickForIt': 'ここをクリックして表示 ',
  'task.redeem.copy': 'コピー ',
  'task.redeem.copied': 'コピー済み ',
  'task.redeem.payForNow': '今すぐ支払う ',
  'task.redeem.orderWill': '注文は {time} に期限切れになります。お早めにお支払いください。',
  'task.redeem.dataReady': 'データ準備中です。少々お待ちください...',
  'task.redeem.drawed': '当選 ',
  'task.redeem.receive': '今すぐ受け取る ',
  'task.redeem.drawed.limitDate': '賞品の有効期限 ',
  'task.redeem.drawed.waitForit': '{lotteryName} 当選、配布待ち（2 営業日以内に完了）',
  'task.redeem.drawed.waitForit.physical': '{lotteryName} 当選、受け取りには WeChat カスタマーサービス chenhan_xy にご連絡ください ',
  'task.redeem.drawed.violation': '{lotteryName} に当選しましたが、違反により注文がキャンセルされました。',
  'task.redeem.drawed.success': '{lotteryName} に当選し、会員権がアカウントにチャージされました。ご確認ください。',
  'task.redeem.drawed.goods.success': '{lotteryName} に当選し、アカウントにチャージされました。ご確認ください。',
  'task.redeem.drawed.goods.success.physical': '{lotteryName} に当選し、賞品が配布されました。',
  'task.redeem.drawed.svip.success': 'スーパー VIP 会員権がアカウントにチャージされました。ご確認ください。',
  'task.redeem.drawed.vip.success': 'VIP 会員権がアカウントにチャージされました。ご確認ください。',
  'task.redeem.drawed.violation.closed': '違反により注文がキャンセルされました ',
  'task.redeem.violation.contact': '違反によりコインを獲得、抽選報酬は送付されません。質問がある場合はinfo@quickfox.com.cnにメールを送信してください。',
  'task.redeem.limit.contact': '招待されたアカウントに異常操作があったため、交換が一時的に制限されています。info@quickfox.com.cnに申し立て資料を送信してください。QuickFox アカウントと最近招待したすべての友達とのチャット記録を含めてください。',
  'task.redeem.order.fail': 'この注文は期限切れで、消費されたコインはアカウントに返金されました。',
  'task.redeem.draw.customer.service': '詳細を確認し、WeChat を追加して交換を完了してください。',
  'task.redeem.drawLink.tips': 'リンク受け取り：配布待ち（2 営業日以内に完了）',
  'task.redeem.drawLink.limit.tips': '商品コードは {expireTime} に期限切れになります。できるだけ早く交換してください。',
  'task.redeem.noname': 'まだ名前なし ',
  'task.redeem.checkMethod': '交換方法を表示 ',
  'task.redeem.invite.reward': '邀请有礼',
  'task.redeem.follow.reward': '关注公众号',
  'task.redeem.bind.reward': '绑定手机/邮箱',
  'task.redeem.signin.reward': '每日签到',
  'task.redeem.intlAuth.reward': '留学认证奖励',
  'task.redeem.coin.reward': '金币兑换',
  'task.redeem.game.reward': '小游戏奖励',

  'task.event.rule': 'イベントルール ',

  'task.event.question': 'よくある質問',
  'task.event.needToKnow': 'イベントのお知らせ',
  'task.goods.loadGoods.fail': '商品リストの読み込みに失敗しました',
  'task.goods.coin.loadFailed': 'ゴールドコインの読み込みに失敗しました',
  'task.goods.shop.requreUpdate': 'ゴールドコインショップへのアクセスに異常があります。より良いユーザー体験のために、最新のクライアントにアップグレードしてください',
  'task.goods.coin.less.loadFailed': '残りのゴールドコインの読み込みエラー',
  'task.goods.coin.balance': 'ゴールドコイン残高',
  'task.goods.coin.detail.view': 'ゴールドコインの取引記録を表示',
  'task.goods.coin.exchange.record': 'ショッピングモール交換注文を表示',
  'task.lottery.detailPv': '抽選商品詳細ページの閲覧数',
  'task.lottery.waitMsg': '抽選中です、もう少しお待ちください、すぐに結果が発表されます～',
  'task.lottery.drawOut': '賞品がすべてなくなりました、補充中ですので、また後で来てください～',
  'task.lottery.networkErrMsg': 'ネットワークエラーが発生しました、ネットワークを確認して再度お試しください～',
  'task.lottery.Replenishment': '賞品がすべてなくなりました、補充中ですので、また後で来てください～',
  'task.lottery.balance.lessMsg': 'ゴールドコインが不足しています。早くゴールドコインを稼ぎましょう～',
  'task.lottery.forAWhile': '現在抽選できません。後でまた確認してください～',
  'task.lottery.luckyId.error': '当選 ID エラー:',
  'task.lottery.luckyId.cannotFind': '賞品が見つかりません。当選 ID は:',
  'task.lottery.interrupt': 'あら、抽選が予期せず中断されました！後で再試行するか、カスタマーサービスにお問い合わせください',
  'task.lottery.start.first': 'まず始めてください',
  'task.lottery.number.error': '数字エラー',
  'task.lottery.now': 'すぐに',
  'task.lottery': '抽選',
  'task.lottery.add': '補充',
  'task.lottery.rewards': '賞品中',
  'task.lottery.draw.congratulate': 'おめでとうございます！当選しました',
  'task.lottery.coin.once': 'コイン / 回',
  'task.lottery.draw.view': 'システムが配布した後に受け取ることができ、"福利厚生 - 交換記録" ページで進捗状況を確認できます。',
  'task.lottery.draw.viewReward': '賞品はあなたのアカウントに送信されました。"福利厚生 - 交換記録" ページで確認できます。',
  'task.lottery.draw.physicalGoods': 'お早めにカスタマーサービスにお問い合わせいただき、"QuickFox App - 福利厚生 - 交換記録" ページで連絡先と進捗状況を確認してください～',
  'task.lottery.rule': '抽選ルール',
  'task.lottery.rulePv': '抽選ルールクリック数',
  'task.lottery.myRewardPv': '私の賞品クリック数',
  'task.lottery.tab.item1.part1': 'イベント',
  'task.lottery.tab.item1.part2': 'ルール',
  'task.lottery.tab.item2.part1': '私の',
  'task.lottery.tab.item2.part2': '賞品',
  'task.lottery.coin.earnIt': 'コインを稼ぐ>>',
  'task.lottery.more': 'もっと抽選',
  'task.lottery.result': '抽選結果',
  'task.lottery.again': 'もう一度抽選',
  'task.lottery.toView': '見に行く',
  'task.lottery.lickDrawNowPv': '"今すぐ抽選"ボタンの成功クリック数',
  'task.lottery.error': '抽選エラー：',
  'task.lottery.notLogin': '未ログイン',
  'task.walfare.center': '福祉センター',
  'task.walfare.info.refresh.done': '個人情報を更新しました ',
  'task.walfare.info.refresh.error': '個人情報の更新エラー ',
  'task.walfare.refreshed': '更新しました ',
  'task.walfare.refresh.error': '更新エラー ',
  'task.walfare.viewPv': '福利ページの閲覧数 ',
  'task.walfare.all': 'すべて ',
  'task.walfare.giftMoney': '赤い封筒 ',
  'task.walfare.coin.clickPv': 'ゴールドコイン詳細クリック数 ',
  'task.walfare.coin.left': '残りのゴールドコイン ',
  'task.walfare.coin.mine': '私のゴールドコイン ',
  'task.walfare.coin.expire.thisMonth': '今月期限切れコイン ',
  'task.walfare.coin.expire.time': '有効期限 ',
  'task.walfare.coin.earn': 'コインを獲得 ',
  'task.walfare.exchange.record': '交換記録 ',
  'task.walfare.exchange.recordPv': '交換記録クリック数 ',
  'task.walfare.coin.descrip': 'コイン説明 ',
  'task.walfare.coin.descrip.usage': 'コインは何に使われますか？',
  'task.walfare.coin.descrip.usage.part1': 'コインは QuickFox の仮想通貨資産で、福利センターで現金ボーナスや VIP 会員などと交換できます。',
  'task.walfare.coin.descrip.channel': 'コインの獲得方法 ',
  'task.walfare.coin.descrip.channel.part1': 'デイリーチェックイン、友達の招待、QuickFox 公式アカウントのフォローなどのタスクを完了することでコインを獲得できます。',
  'task.walfare.coin.descrip.expire': 'ゴールドコインの有効期限について:',
  'task.walfare.coin.descrip.expire.part1': '毎月生成されるコインは 3 ヶ月後に期限切れになります。今月期限切れになるコインは期限切れコインリストに追加され、期限切れ間近のコインが優先的に使用されます。期限内に交換しないと、コインは期限切れになり、復元できません。',
  'task.walfare.coin.noticePv': 'お知らせクリック数 ',
  'task.walfare.detail.view': '詳細を見る ',
  'task.walfare.tasks.more': 'その他のタスク ',
  'task.walfare.tasks.clickPv': 'その他のタスククリック数 ',
  'task.goods.clickPv': '商品クリック数 ',
  'welfare.invitev2.page.title': '友達にメンバーシップを贈る ',
  'welfare.invitev2.page.getFail': 'データの取得に失敗しました ',
  'welfare.invitev2.page.directions': 'フレンドリーリマインダー：無料ギフトクォータを有効にした後、最新の有料注文は 7 日間の無条件返金資格を失います。',
  'welfare.invitev2.rule.title': 'ギフトルール ',
  'welfare.invitev2.rule.content': `
    1、VIP特権ユーザーは月3回までメンバーシップ招待枠を有効化可能(購入履歴あり・有効化時残存期間＞30日、継続課金ユーザーは2ヶ月連続更新かつ返金/解約なし)。リンク共有後、友達が登録完了すると対応期間のQuickFoxメンバーシップを獲得可能。<br/> 
    2、毎回贈呈枠を活性化する際、最新の有料注文の7日間の無理由返品資格が取り消されます。この規則に同意したことを確認してから、贈呈枠を活性化してください。<br/> 
    3、同じ携帯電話番号は15日間の会員を1回のみ受け取ることができ、再度は受け取れません。<br/> 
    4、ユーザーがイベントに参加する際、ユーザーが得た特典を利用して営利または違法な利益を得る、特典をいかなる形でも譲渡または移転する、本人以外が使用する場合、またはQuickFoxがユーザーが特典を不適切に使用していると合理的に疑う場合、QuickFoxはユーザーの特典資格を取り消し、関連する違反取引を取り消し、特典を回収する権利を有します。<br/> 
    5、このイベントに関する情報やサポートが必要な場合は、QuickFoxのオンラインサービス担当者までお問い合わせください。本イベントはアップル株式会社（Apple Inc.）とは関係ありません。<br/> 
    6、法律の範囲内で、QuickFoxは本イベントに対して最終的な解釈権を保有します。<br/>`,
  'welfare.invitev2.link.title': 'QuickFox 会員シップカードをプレゼントします ',
  'welfare.invitev2.link.descrip': 'QuickFox 帰国アクセラレーター、中国人の帰国加速の第一選択ブランド、加速が一歩先を行く ',
  'welfare.invitev2.card.type': 'QuickFox 会員',
  'welfare.invitev2.card.nocheck': '未受領 ',
  'welfare.invitev2.card.sendTo': '末尾 {account} の友達にプレゼントしました ',
  'welfare.invitev2.msgs.title': '友達にメッセージを残す ',
  'welfare.invitev2.msgs.next': '別のものに変更 ',
  'welfare.invitev2.btn.allCheck': 'すべてのメンバーシップカードが友達に受け取られました ',
  'welfare.invitev2.btn.giftNow': '今すぐプレゼント ',
  'welfare.invitev2.btn.timeEnd': 'ギフト時間が終了しました ',
  'welfare.invitev2.btn.submitAgain': 'ギフトの継続をリクエスト ',
  'welfare.invitev2.btn.upgradeToVip': 'VIP にアップグレード ',
  'welfare.invitev2.btn.leftTime': '残りのギフト時間 ',
  'welfare.invitev2.btn.copyLink': '共有リンクをコピー ',
  'welfare.invitev2.btn.copied': 'ギフトリンクがコピーされました ',
  'welfare.invitev2.modal.cantGift': '現在、メンバーシップを贈ることができません ',
  'welfare.invitev2.modal.content': '現時点でギフト条件を満たしていない場合は、会員センターで会員期間を延長してから、お友達にメンバーシップをギフトとして贈ることができます。 ',
  'welfare.invitev2.modal.getIt': '寄付ルール',
  'welfare.invitev2.modal.buyVip': '今すぐメンバーシップを購入 ',
  'task.detail.email.title': 'アカウント情報の充実タスク',
  'task.detail.email.rule1': 'イベントルール ',
  'task.detail.email.rule2': 'ユーザーはメールまたは電話番号をバインドして報酬を受け取ることができます ',
  'task.detail.email.rule3': '今回のイベント報酬は一度しか受け取れず、繰り返し受け取ることはできません ',
  'task.detail.email.rule4': 'メールまたは電話番号をバインドしたユーザーは、このページから直接イベント報酬を受け取ることができます。メールまたは電話番号で登録したユーザーには自動的に報酬が配布されます ',
  'task.detail.email.rule5': 'プレゼントされた時間はリアルタイムで付与されます。クーポンコードはメールまたは SMS で送信され、メッセージ内の短い URL からのみ参加できます ',
  'task.detail.email.btn': 'バインドして受け取る ',
  'task.detail.email.received': '受け取り済み ',
  'task.detail.email.finished': 'イベントは終了しました ',
  'task.detail.email.bind': '今すぐバインド ',
  'task.detail.email.bound': '今すぐ受け取る ',
  'task.detail.email.success': '受け取りに成功 ',
  'task.detail.email.failed': '受け取り失敗 ',
  'task.detail.email.verify.pleaseEnterCorrectEmail': '正しいメールアドレスを入力してください ',
  'task.detail.email.verify.pleaseEnterEmail': 'メールアドレスを入力してください ',
  'task.detail.email.verify.pleaseEnterCorrectPhone': '正しい携帯電話番号を入力してください ',
  'task.detail.email.verify.pleaseEnterPhone': '携帯電話番号を入力してください ',
  'task.detail.email.verify.pleaseEnterCorrectVerifyCode': '正しい認証コードを入力してください ',
  'task.detail.email.verify.pleaseEnterVerifyCode': '認証コードを入力してください ',
  'task.detail.email.verify.pleaseEnterDigitPsw': '6-16 桁の英数字組み合わせのパスワードを入力してください ',
  'task.detail.share.title': 'シェアで報酬 ',
  'task.detail.share.min5m': '5M 以下の画像を選択してください ',
  'task.detail.share.noPass': '審査に不合格、再提出してください ',
  'task.detail.share.submit': '審査を提出 ',
  'task.detail.share.underReview': '審査中 ',
  'task.detail.share.pass': '審査通過、報酬を支給しました ',
  'task.detail.share.save': '画像を保存 ',
  'task.detail.share.cancel': 'キャンセル ',
  'task.detail.share.noUpload': 'まず共有スクリーンショットをアップロードしてください！',
  'task.detail.share.saveSuccess': '画像がアルバムに保存されました ',
  'task.detail.share.saveFail': '画像の保存に失敗しました！',
  'task.detail.share.successTip': '審査に提出されました。しばらくお待ちください ',
  'task.detail.share.version': '現在のバージョンが低いです。"マイページ - マイアカウント" ページに移動してバインディングを完了してください ',
  'task.detail.share.message': '画像をアップロードしてください！',
};
// 邀请裂变第4期
const pointEventV4 = {
  'V4.welfare.center.title': '福利厚生センター ',
  'V4.welfare.center.more': 'もっと特典 ',
  'V4.welfare.foreignStudent.title': '留学生限定特典 ',
  'V4.welfare.foreignRule.title': 'ルール説明 ',
  'V4.welfare.redeem.norecord.goForIt': 'まだ記録がありません、早く特典を受け取りに行きましょう～',
  'V4.welfare.record.title': '特典記録 ',
  'V4.welfare.miniGame.title': 'ミニゲームの任務 ',

  'V4.welfare.tasks.invite': '友達を招待',
  'V4.welfare.tasks.wx': '公式アカウントをフォロー',
  'V4.welfare.tasks.email': '電話番号/メールアドレスをバインド',
  'V4.welfare.tasks.sign': '毎日のチェックイン',
  'V4.welfare.tasks.exchange': 'コインを交換する',
  
  'V4.welfare.tasks.invite.desc': '友達を招待すると、購入した時間の10％が付与されます',
  'V4.welfare.tasks.wx.desc': 'QuickFoxをフォローして2時間のVIP特典を獲得',
  'V4.welfare.tasks.email.desc': 'アカウントをバインドして2時間のVIP特典を獲得しましょう',
  'V4.welfare.tasks.sign.desc': '継続的なチェックインでVIPタイムを獲得できます',
  'V4.welfare.tasks.exchange.desc': 'ワンタイムコイン交換',

  'V4.welfare.tasks.invite.btn': '行く',
  'V4.welfare.tasks.sign.btn': '行く',
  'V4.welfare.tasks.exchange.btn': '交行く換へ移動',
  'V4.welfare.tasks.hot': 'ホットタスク',
  'V4.welfare.tasks.completed': '行く',
  'V4.welfare.tasks.goForIt': '行く',
  'V4.welfare.tasks.exchanged': '行く',
  'V4.welfare.tasks.goExchange': '行く',

  'V4.welfare.intlAuth.title': '留学生認証',
  'V4.welfare.intlAuth.desc': '留学生認定証を取得すると、福利厚生センターで留学生限定の特典を受けることができます。',
  'V4.welfare.intlAuth.btn': '留学生特典の受給',
  'V4.welfare.intlAuth.know': '知っている',
  'V4.welfare.intlAuth.goForItBtn': '今すぐ認証してください',

  'V4.welfare.vip.title': 'VIP特典',
  'V4.welfare.vip.desc': 'QuickFoxVIP メンバーシップを購入し、メンバーシップの有効期限が切れていないすべてのユーザーには VIP 特権があります。福利厚生センターではVIP限定特典が受けられます。 ',
  'V4.welfare.vip.btn': 'VIP期間の更新',
  'V4.welfare.vip.know': '知っている',
  'V4.welfare.vip.upgrade': '今すぐアップグレード',

  'V4.welfare.receive.record': '受信記録',

  'V4.welfare.btn.receive': '受け取る',
  'V4.welfare.btn.received': '受け取り済み',
  'V4.welfare.btn.nextMonth': '{month}月に受け取る',

  'V4.welfare.btn.monthWelfare': '{month} 月額福祉',

  'V4.welfare.empty.noData': 'まだデータがありません',
  'V4.welfare.btn.moreWelfare': '福祉の充実 >',

  // 福利详情页
  'V4.welfare.detail.title': '福祉の詳細',
  'V4.welfare.detail.myRight': '私の権利',
  'V4.welfare.detail.welfareDesc': '福祉の説明',
  'V4.welfare.detail.upgradeToVip': 'VIPにアップグレード',
  'V4.welfare.detail.upgradeToVip.btn': '今すぐアップグレード',
  'V4.welfare.detail.received': '請求済み - 記録で確認',
  'V4.welfare.detail.nextMonth': '{month}に徴収してください',
  'V4.welfare.detail.complete': '留学生証明書の提出',

  'V4.welfare.detail.received.success': '正常に受信されました。VIP 特典がアカウントに再チャージされました。受け取った特典を確認するには、「特典記録」ページにアクセスしてください。',
  'V4.welfare.detail.received.goForIt': '今すぐ始めよう',
  'V4.welfare.detail.received.success.tip1': '正常に受け取りました。購入ページに進み、福利厚生割引をお楽しみください。 ',
  'V4.welfare.detail.received.success.tip2': '「マイ」ページに移動して収集記録を確認することもできます〜',
  'V4.welfare.detail.received.success.btn': '今すぐ購入',
  'V4.welfare.detail.received.success.tip3': '正常に受信しました。製品コード: {key}\n「福利厚生記録」ページに移動して、取得した権限を確認できます',
  'V4.welfare.detail.received.success.tip4': 'ヒント: 認証メールボックスの購入リンクをクリックすると、製品コードを使用して直接購入できます~',

  'V4.welfare.detail.received.success.tip5': '温かいリマインダー',
  'V4.welfare.detail.received.success.tip6': "{goodsName} 福利厚生商品には、{remainingTimeDaysMore} 日を超える VIP 時間が必要です。現時点では受け取る条件を満たしていません。受け取る前にメンバーシップを購入しますか?'",
  'V4.welfare.detail.received.success.btn2': 'VIPを購入',
  'V4.welfare.detail.received.success.title': '正常に受信されました',
  'V4.welfare.detail.received.success.tip7': '一般ユーザーとして毎月 {thisMonth} の福利厚生を受けられます。 VIPにアップグレードすると、より高いレベルの福利厚生を受けることができます。アップグレードが必要ですか? ',
  'V4.welfare.detail.received.success.btn3': 'VIP アップグレード',
  'V4.welfare.detail.received.failed': '受信に失敗しました',
  'V4.welfare.detail.received.success.btn4': 'ベーシックで続ける',
  'V4.welfare.detail.received.success.tip8': '受領しました。受領記録を確認してください',
  // 暂停管理页
  'V4.welfare.pause.title': '請求管理を一時停止',
  'V4.welfare.pause.rule': 'ルール',
  'V4.welfare.pause.rule.title': '一時停止ルール',
  'V4.welfare.pause.rule.know': 'すでに理解している',
  'V4.welfare.pause.resume': '請求を再開する',
  'V4.welfare.pause.pause': '請求を一時停止します',
  'V4.welfare.pause.resume.tip': '一時停止を事前にキャンセルすると、一時停止時間は返されません。再開しますか? ',
  'V4.welfare.pause.resume.cancel': 'キャンセル',
  'V4.welfare.pause.resume.confirm': '確認',

  'V4.welfare.pause.select': '一時停止時間を選択してください',
  'V4.welfare.pause.failed': '一時停止に失敗しました',

  'V4.welfare.pause.record': '記録',

  'V4.welfare.pause.thisYear': '今年',
  'V4.welfare.pause.remainCount': '一時停止回数',
  'V4.welfare.pause.count': '回',
  'V4.welfare.pause.remainMon': '合計一時停止時間',
  'V4.welfare.pause.month': '月',

  'V4.welfare.pause.myRight': '私の権利',
  'V4.welfare.pause.expiredTip': 'VIP の有効期限が切れているため、一時停止できません。来て',
  'V4.welfare.pause.buyGuide': 'メンバーシップのチャージ',
  'V4.welfare.pause.buyGuide.tip': 'うん〜',
  'V4.welfare.pause.usedTip': '年間の一時停止回数または期間を使い果たしたため、再度一時停止することはできません。 ',

  'V4.welfare.pause.currentStatus': '現在の会員ステータス',
  'V4.welfare.pause.status.pause': '請求を一時停止する',
  'V4.welfare.pause.tatus.normal': '通常の請求',

  'V4.welfare.pause.pauseTimeType.minute': '分',
  'V4.welfare.pause.pauseTimeType.hour': '時間',
  'V4.welfare.pause.pauseTimeType.day': '日',
  'V4.welfare.pause.expired': 'VIPの有効期限が切れました',
  'V4.welfare.pause.pauseTime': '一時停止は',
  'V4.welfare.pause.resumeTime': '請求を再開する時間',
  'V4.welfare.pause.selectTip': '一時停止期間を選択',
  'V4.welfare.pause.selectPlaceholder': '選択されていません',

  'V4.welfare.pause.record.submitTime': '送信時刻:',
  'V4.welfare.pause.record.type': '操作タイプ:',
  'V4.welfare.pause.record.usedTime': '使用された一時停止時間:',
  'V4.welfare.pause.record.remainTime': '残りの一時停止時間:',
  'V4.welfare.pause.record.pause': '請求を一時停止します',
  'V4.welfare.pause.record.resume': '手動で再開',
  'V4.welfare.pause.record.month': '月',

  // 留学生认证页
  'V4.welfare.intlAuth.notLogin': 'まだログインしていません',
  'V4.welfare.intlAuth.completed': '留学生認定を完了しました',
  'V4.welfare.intlAuth.goForIt': '留学生認定をすぐに完了する',
  'V4.welfare.intlAuth.pause': 'メンバーシップを一時停止',
  'V4.welfare.intlAuth.pause.desc': '休暇中の請求を一時停止',
  'V4.welfare.intlAuth.vip.title': '7日間VIP会員',
  'V4.welfare.intlAuth.vip.desc': '初回認証後',
  'V4.welfare.intlAuth.discount.title': '年間10%オフ',
  'V4.welfare.intlAuth.discount.desc': '毎月10%オフクーポンをゲット',
  'V4.welfare.intlAuth.invite.title': '友達ボーナス+5%',
  'V4.welfare.intlAuth.invite.desc': '追加時間特典',
  'V4.welfare.intlAuth.coupon.title': 'Gonest 送料50￥クーポン',
  'V4.welfare.intlAuth.coupon.desc': '留学生限定クーポン3枚',
  'V4.welfare.intlAuth.contact.title': 'WeChatアカウントを追加して報酬を受け取る',
  'V4.welfare.intlAuth.contact.desc': '素敵なプレゼントがいっぱい',
  'V4.welfare.intlAuth.contact.btn': 'ゲット',
  'V4.welfare.intlAuth.received': 'ゲット',
  'V4.welfare.intlAuth.receive': 'ゲット',
  'V4.welfare.intlAuth.welfare.title': '認証後の限定特典',
  'V4.welfare.intlAuth.pause.btn': 'ゲット',
  'V4.welfare.intlAuth.receive.btn': 'ゲット',
  'V4.welfare.intlAuth.invite.btn': 'ゲット',
  'V4.welfare.intlAuth.email.error': 'メールの形式が正しくありません!',
  'V4.welfare.intlAuth.desc.tip': '以下の情報は、留学生の本人確認のみに使用され、ログイン情報やパスワードとしては使用されません。申請できるのは留学生（香港、マカオ、台湾在住の学生を含む）のみであり、学生の教育機関向けメールアドレスは本物かつ検証可能なものである必要があります。',
  'V4.welfare.intlAuth.auth.btn': '認証',
  'V4.welfare.intlAuth.email.placeholder': '学校教育メール',
  'V4.welfare.intlAuth.verifyCode.placeholder': 'メール確認コード',
  'V4.welfare.intlAuth.email.error.tip': 'メールアドレスが認証できない場合は、広告メールなどで傍受されていないかご確認ください。その他の質問については、こちらをクリックしてください。',
  'V4.welfare.intlAuth.email.error.tip.link': 'カスタマーサービスにお問い合わせください',

  'V4.welfare.intlAuth.getCode': '認証コードを取得する',
  'V4.welfare.intlAuth.getCode.error': '認証コードの取得に失敗しました',
  'V4.welfare.intlAuth.getCode.success': '確認コードが送信されました。ご確認ください',
  'V4.welfare.intlAuth.certification.success': '認証に成功しました',
  'V4.welfare.intlAuth.certification.error': '認証に失敗しました',
  'V4.welfare.intlAuth.getCertificateInfo.error': 'データの取得に失敗しました',
  'V4.welfare.intlAuth.getWelfare.success': '7日間のVIP期間が正常に受信されました',
  'V4.welfare.intlAuth.getWelfare.error': '収集に失敗しました',
  'V4.welfare.intlAuth.getCode.reGet': '再取得',
  'V4.welfare.foreignRule.getCertificateInfo.error': 'データの取得に失敗しました',
}

const cancel = {
  'cancel.title.reminder': 'アカウント削除のリマインダー ',
  'cancel.title.auth': '本人確認 ',
  "cancel.reminder.artical": `
  <div style="color: #90A1DC; ">
    アカウントの削除は元に戻せない操作です。以下の重要な注意事項をしっかりとお読みください：
  </div>
  <p>
    1、アカウントを削除する前に、すべての決済プラットフォームの継続月額サービスを解約していることを確認してください。対応する<a href="{url}">解約チュートリアル</a>を参照して解約を完了できます。あなたの権利を保護するため、解約していない場合、アカウントの削除は完了できません。
  </p>
  <p>
    2、アカウント削除申請から削除完了まで15日間の待機期間があります。待機期間中はいつでも削除を中止できます。待機期間終了後、アカウントは削除されます。
  </p>
  <p>
    3、アカウントが削除されると、すべてのアカウントデータが消去されます。削除されたアカウントはログインできず、復元もできません。残りの会員期間、コイン残高などを含むすべての特典も消去され、復元できません。
  </p>
  <p>
    4、アカウントが削除されると、該当アカウントに関連付けられた携帯電話番号、メールアドレスおよびサードパーティのログイン情報が解放されます。解放されたログイン情報は、他のアカウントの登録または関連付けに使用できます。
  </p>
  <p>
    5、削除済みのアカウントを再登録する場合、以前に享受した新規ユーザー特典、新規ユーザーのスーパーVIP期間付与、招待イベントのコイン報酬などを取得できません。
  </p>
`,
  'cancel.reminder.agree': '読み同意しました: QuickFox',
  'cancel.reminder.agreement': 'アカウント解約契約 ',
  'cancel.reminder.next': '次へ ',
  'cancel.reminder.read': '上記の注意事項をよくお読みください ',
  'cancel.reminder.cancelSign': '現在、{signTypeText} の月額サービスが解約されていません。解約を確認してからアカウント削除を行ってください。',
  'cancel.auth.input': '現在のアカウントパスワードを入力して認証を完了してください ',
  'cancel.auth.confirm': '解約確認 ',
  'cancel.auth.tips': 'キャンセルを申請した後、15 日間のキャンセル待機期間があります。この期間中はいつでも再ログインしてキャンセルを終了できます。',
  'cancel.auth.pwd': 'パスワードを入力してください ',
  'cancel.auth.relogin.third': '確認を完了するには、いずれかのサードパーティアカウントで再ログインしてください ',
  'cancel.auth.relogin': '再ログイン ',
  'cancel.auth.please': 'お願いします ',
  'cancel.auth.finish': '確認済み ',
  'cancel.auth.unDetected': 'サードパーティのアカウントが検出されませんでした。カスタマーサービスにお問い合わせください ',
  'cancel.auth.inconsistent': 'ログインしたサードパーティのアカウントが現在バインドされているアカウントと一致しません。もう一度お試しください ',
  'cancel.auth.failed': 'サードパーティのアカウント検証に失敗しました ',
  'cancel.auth.failed.accident': '検証に失敗しました ',
  'cancel.wx.pay': '自動更新の管理 ',
  'cancel.tips.userInfoFailed': 'ユーザー情報を取得できませんでした。後でもう一度お試しください ',
  'cancel.tips.unexpectedError': '予期せぬエラーが発生しました ',
  'cancel.tips.failToCheckSignStatus': '契約状態の照会に失敗しました ',
};
const memberi = {
  'memberi.title': '会員交換 ',
  'memberi.valicode': '引き換えコードを入力してください ',
  'memberi.loginTip': 'ログイン後に交換できます ',
  'memberi.loginBtn': 'ログイン / 登録 ',
  'memberi.placeholder': '引き換えコードを入力してください',
  'memberi.getcode': '今すぐ交換する ',
  'memberi.descTitle': '交換ルール ',
  'memberi.desc1': '引き換えコードは QuickFox 専用の特典商品です。引き換えコードを販売したり、商業行為を行わないでください。違反した場合、QuickFox は会員期間を取り消す権利を留保します。',
  'memberi.desc2': '交換に成功すると、対応する VIP 期間が付与されます。',
  'memberi.desc3': 'VIP 会員期間を既に持っているユーザーや契約中のユーザーは、交換成功後に VIP 期間が延長されます。',
  'memberi.desc4': 'QuickFox は法律の範囲内で本規則の解釈権を有します。ご質問がある場合は、オンラインカスタマーサービスにお問い合わせください。',
  'memberi.success': '交換成功 ',
  'memberi.fail': '交換失敗 ',
  'memberi.success1': '獲得済み ',
  'memberi.ok': 'はい ',
  'memberi.blacklistTips': '現在のアカウントにはリスクがあるため、引き換えコードを使用できません。',
};

const customizedMembership = {
  'customizedMembership.viptimer': '残り時間 ',
  'customizedMembership.concat': 'カスタマーサービスに今すぐ相談して、独占カスタムルートを獲得 ',
  'customizedMembership.desc1': '独占帯域幅保証 ',
  'customizedMembership.desc2': '4K 動画即時再生 ',
  'customizedMembership.desc3': 'スムーズなストリーミング ',
  'customizedMembership.desc4': '二重ラインでダブル安定性 ',
  'customizedMembership.desc5': '3 デバイス同時オンライン ',
  'customizedMembership.desc6': '全クライアントサポート ',
  'customizedMembership.btn': '更新相談 ',
  'customizedMembership.btn1': '購入相談 ',
  'customizedMembership.title': 'カスタマイズ会員 ',
};

const sportsQuiz = {
  'sportsQuiz.title': 'イベント詳細 ',
  'sportsQuiz.shareAndGetCoins': 'クイックシェアでコインを獲得 ',
  'sportsQuiz.how2play': 'ゲーム紹介 ',
  'sportsQuiz.rule': 'ワールドカップイベントルール ',
  'sportsQuiz.guessed': 'あなたは推測しました ',
  'sportsQuiz.advance': '進級 ',
  'sportsQuiz.win': '勝利 ',
  'sportsQuiz.draw': '引き分け ',
  'sportsQuiz.guessWithCoins': '{coins} コインで予想する ',
  'sportsQuiz.ifGuessRight': '正しく予想すると獲得 ',
  'sportsQuiz.includes': '試合結果は延長戦と PK 戦を含む ',
  'sportsQuiz.leftTime': '残り予想時間 ',
  'sportsQuiz.leftQuota': '残り参加枠 ',
  'sportsQuiz.end': 'この試合の予測は終了しました ',
  'sportsQuiz.others': '他の試合をフォローしてください～',
  'sportsQuiz.getFromNotice': '（メッセージセンターから受け取る）',
  'sportsQuiz.youHaveGuessed': '予測に参加しました ',
  'sportsQuiz.ifThen': 'もし {predict}{result} あなたは得ることができます ',
  'sportsQuiz.guessedRight': '正しい予測おめでとうございます、あなたの ',
  'sportsQuiz.goGet': '配布されました。メッセージセンターで受け取ってください～',
  'sportsQuiz.yourGuess': 'あなたの予想は：',
  'sportsQuiz.guessedWrong': '予想が間違っていました、次回も頑張ってください～',
  'sportsQuiz.goGetCoins': 'コインを稼ごう ',
  'sportsQuiz.platforms': '以下のライブプラットフォームで観戦できます ',
  'sportsQuiz.useQF': 'Quickfox ビデオモードを使用して、ワンクリックで著作権制限を解除 ',
  'sportsQuiz.cctv': 'CCTV ビデオ ',
  'sportsQuiz.yangshipin': 'CCTV ビデオ ',
  'sportsQuiz.migu': 'ミグビデオ ',
  'sportsQuiz.tiktok': 'ティックトック ',
};
const device = {
  'device.title': 'ログイン済みデバイス ',
  'device.dialog.title': 'ログアウト ',
  'device.dialog.centent': 'ログアウト後、このデバイスで再度ログインするにはアカウントの確認が必要です。ログアウトしますか？',
  'device.dialog.ok': '確認 ',
  'device.dialog.cancel': 'キャンセル ',
  'applyRecord.title': '申請記録 ',
  'applyRecord.exitFailed': '拒否',
  'applyRecord.using': '公開済み',
  'applyRecord.waiting': '処理待ち',
  'device.thisDevice': 'この端末 ',
  'device.exit': '終了 ',
  'device.offline': 'オフライン ',
  'device.exitSuccess': '終了成功 ',
};
// 绑定邮箱活动
const bindEmail = {
  'bindEmail.title': 'メールをバインド ',
  'bindEmail.success.tip': 'メール / 電話番号の紐付けに成功しました！',
  'bindEmail.areaCode': '市外局番 ',
  'bindEmail.phoneEmpty': '電話番号',
  'bindEmail.emailEmpty': '電子メールアドレス',
  'bindEmail.switchTo': ' ',
  'bindEmail.getCode': '検証コード',
  'bindEmail.findCountry': '国番号または市外局番',
  'bindEmail.emailVerify': '正しいメールアドレスを入力してください ',
  'bindEmail.phoneVerify': '正しい携帯電話番号を入力してください ',
  'bindEmail.codeVerify': '検証コード ',
  'bindEmail.pwsVerify': '6～16桁の文字と数字の組み合わせ',
  'bindEmail.pwsEmpty': 'パスワードを入力してください ',
  'bindEmail.codeEmpty': '検証コード',
  'bindEmail.phone': '携帯電話 ',
  'bindEmail.email': 'メール ',
};
// 任务补充
const taskSupplement = {
  'taskSupplement.redemptionDetails': '交換詳細ページ ',
  'taskSupplement.missionRules': 'タスクルール ',
  'taskSupplement.shareScreenshot': '共有スクリーンショットを選択 ',
  'taskSupplement.supportChannel': '現在、小紅書、WeChat、微博、抖音などのプラットフォームでのスクリーンショット共有をサポートしています。',
  'taskSupplement.advisoryService': 'タスクのルールに従ってください。質問がある場合はカスタマーサービスにお問い合わせください。',
  'taskSupplement.auditPrompt1': '審査期間中は共有コンテンツを表示したままにしてください。',
  'taskSupplement.auditPrompt2': '承認後、100 ゴールドコインが自動的に報酬として付与されます。お待ちください。',
  'taskSupplement.sharePoster': 'ポスターを共有 ',
  'taskSupplement.saveImg': '画像を長押しして保存 ',
  'taskSupplement.rulesDesc4': '今から、すべての登録ユーザーは、タスクページでソーシャルプラットフォーム（Xiaohongshu、WeChat、Weibo、Douyin、Facebook、Twitter、Instagram、Tiktok などを含む）に QuickFox 共有ポスターが含まれるスクリーンショットをアップロードできます。承認後、100 ゴールドコインを報酬として受け取ることができます。',
  'taskSupplement.rulesDesc5': '各ユーザーは 1 つのタスクを完了できます。審査中は、ソーシャルプラットフォームでコンテンツが表示されるようにしてください。そうしないと拒否される可能性があります。',
  'taskSupplement.rulesDesc6': '2 営業日で審査完了 ',
  'taskSupplement.rulesDesc7': 'マーケティング活動中、ユーザーが利益を得るためまたは不正に特典を利用したり、特典を譲渡したり、不正使用した場合、QuickFox は特典を取り消し、取引を無効にすることができます。',
  'taskSupplement.rulesDesc8': '本イベントに関する情報やサポートが必要な場合は、QuickFox オンラインサポートにお問い合わせください。Apple Inc. とは関係ありません。',
  'taskSupplement.rulesDesc9': 'QuickFox は法的範囲内で本イベントの最終解釈権を留保します。',
  'taskSupplement.xiecheng': 'トリップランディングページ ',
};
// 微信续费补充
const wxPayManage = {
  'wxPayManage.activatedBusiness': '有効化されたサービス ',
  'wxPayManage.weChatPay': 'WeChat Pay',
  'wxPayManage.continuousMonthlyMembership': '月額サブスクリプション会員 ',
  'wxPayManage.nextRenewalTime': '次回自動引き落とし時間 ',
  'wxPayManage.stopService': 'サービスを閉じる ',
  'wxPayManage.successfullyUnsubscribe': 'WeChat 月額サブスクリプションの解約に成功しました ',
};

// 支付宝实名认证
const zfbManage = {
  'zfbManage.cancelledVerification': 'ユーザー認証がキャンセルされました ',
  'zfbManage.enterNumber': '正しい 18 桁の身分証番号を入力してください ',
  'zfbManage.enterX': '身分証の末尾に文字が含まれている場合は入力してください ',
  'zfbManage.enterID': '身分証に登録されている身分証番号を入力してください ',
  'zfbManage.enterName': '身分証に登録されている本名を入力してください ',
  'zfbManage.verificationFailed': '身分証明書情報の検証失敗 ',
  'zfbManage.getCode': 'クライアントに戻って QR コードを再取得してください ',
  'zfbManage.realNameverify': '身元確認 ',
  'zfbManage.successed': '身元確認の完了おめでとうございます ',
  'zfbManage.complete': '完了 ',
  'zfbManage.callChatTextPrefix': '中華人民共和国の居住者以外のユーザーは ',
  'zfbManage.callChatText': 'カスタマーサービスに連絡 ',
  'zfbManage.callChatTextSuffix': '検証を完了 ',
  'zfbManage.authentication': '本人確認利用規約 ',
  'zfbManage.realNameVerifyDesc1': 'アカウントの安全を確保するため、本人確認を完了してください。',
  'zfbManage.realNameVerifyDesc2': '現在の本人確認サービスは「Alipay」によって提供されています。事前に関連アプリをインストールし、認証してください。',
  'zfbManage.realNameVerifyDesc3': '提出された本人情報は本人確認のみに使用され、QuickFox は他のシナリオに適用したり、第三者に開示したりしないことを約束します。',
  'zfbManage.qRealNameverify': 'QuickFox 身元確認 ',
  'zfbManage.enterRealName': '身分証明書の実名を入力してください ',
  'zfbManage.realName': '実名 ',
  'zfbManage.enterRealID': '18 桁の身分証明書番号を入力してください ',
  'zfbManage.IDCode': '身分証明書番号 ',
  'zfbManage.now': 'すぐに確認 ',
  'zfbManage.go': '認証中へ移動 ',
  'zfbManage.upgrade': '現在のクライアントはこのインターフェースをサポートしていません。アップグレードしてください。',
  'zfbManage.failed': '読み込み失敗 ',
  'zfbManage.sendData': '送信されたデータを復号化 ',
};
const blacklistBlocking = {
  'blacklist.youRisk': 'アカウントにリスクがあります ',
  'blacklist.cannot': '一時的に福祉センターのタスクに参加できません ',
  'blacklist.sendEmail': '異議がある場合は、info@quickfox.com.cnにメールで申し立ててください ',
  'vip.cantuse': '企業のサブアカウントはこの操作を実行できません ',
};

const FraudBlacklistBlocking = {
  'blacklist.policy': 'ポリシーの理由により ',
  'blacklist.policyDetail': 'お客様の国または地域ではサービスを提供していません ',
  'blacklist.thanks': 'ご理解とご支援に感謝いたします '
};

const weeklyReward = {
  'weeklyReward.title': '週次福利',
  'weeklyReward.award': '{vipTime}{timeType}VIP加速時間',
  'weeklyReward.award.desc': '専属サービスで会員時間GET',
  'weeklyReward.addNow': '直ちに追加',
  'weeklyReward.cancel': 'キャンセル',
  'weeklyReward.confirm': '確認',
  'weeklyReward.rule': 'ルール',
  'weeklyReward.rule.desc': '1対1専属サービスで会員時間UP',
  'weeklyReward.remainingCount': '今期抽選回数なし',
  'weeklyReward.immediately': '',
  'weeklyReward.lottery': '抽選',
  'weeklyReward.lotteryCount': '{count}チャンス',
  'weeklyReward.thanks': '勝利なし',
  'weeklyReward.record': '記録',
  'weeklyReward.lotteryFailed': '抽選失敗',
  'weeklyReward.activityExpired': 'イベント終了',
  'weeklyReward.activityEnded': 'イベント終了',
  'weeklyReward.soonStart': '未開始',
  'weeklyReward.startLater': '{time}開始',
  'weeklyReward.stock': '在庫{count}%',
  'weeklyReward.notStart': 'このセッションはまだ開始されていません',
  'weeklyReward.ended': 'このセッションは終了しました',
  'weeklyReward.noActivity': '現在、イベントなし',
  'weeklyReward.record.title': '週次福利',
  'weeklyReward.record.time': '{timeStr}VIP時間',
  'weeklyReward.rule.title': 'ルール',
};

const zh_CN = {
  ...about,
  ...contact,
  ...help,
  ...helpDetail,
  ...http,
  ...notice,
  ...tsupport,
  ...Welfare,
  ...PageTitle,
  ...Common,
  ...Tips,
  ...ActivationRecord,
  ...TimeType,
  ...tutorial,
  ...pointEventEnd,
  ...taskCenterV3,
  ...pointEventV4,
  ...cancel,
  ...memberi,
  ...sportsQuiz,
  ...device,
  ...customizedMembership,
  ...bindEmail,
  ...taskSupplement,
  ...wxPayManage,
  ...zfbManage,
  ...blacklistBlocking,
  ...FraudBlacklistBlocking,
  ...weeklyReward,
};

export default zh_CN;
